import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-producer-sidebar',
  templateUrl: './producer-sidebar.component.html',
  styleUrls: ['./producer-sidebar.component.scss']
})
export class ProducerSidebarComponent implements OnInit, OnDestroy {

  currentRoute: string = '';
  private routerSubscription: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    // Définir la route initiale
    this.currentRoute = this.router.url;

    // Écouter les changements de route
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  isActive(route: string): boolean {
    return this.currentRoute.includes(route);
  }

  navigate(route: string): void {
    this.router.navigate([route]);
  }

  openProducerPolicyManagementPage(): void {
    this.router.navigate(['/welcome/menu/bancassurance/producteur-policy-management']);
  }

  openProducerCommissionsPage(): void {
    this.router.navigate(['/welcome/menu/bancassurance/producteur-commissions']);
  }

  openProducerSinistreListPage(): void {
    this.router.navigate(['/welcome/menu/bancassurance/bancassurance-services/claim/producer-claim-historic']);
  }

  openProducerCoassurancePage(): void {
    console.log('ProducerSidebar: navigating to producteur-coassurance');
    this.router.navigateByUrl('/welcome/menu/bancassurance/producteur-coassurance')
      .then(res => console.log('Navigation success:', res))
      .catch(err => console.error('Navigation error:', err));
  }

  openTransferSinistrePage(): void {
    this.router.navigate(['/welcome/menu/bancassurance/producteur-transfertsinistre']);
  }

  goToHome(): void {
    this.router.navigate(['/welcome/menu/bancassurance/producteur-menus']);
  }
}
